(function ($) {
	'use strict';

	$(function () {
		const token = $('meta[name="csrf-token"]').attr('content');
		let lastTrigger = null;
		let payload = null;
		const confirmErrorMessage = window.___('Підтвердіть актуальність даних, щоб надіслати відгук.');

		function escapeHtml(value) {
			return String(value || '').replace(/[&<>"']/g, function (char) {
				return {'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#039;'}[char];
			});
		}

		function modal() {
			let $modal = $('[data-apply-modal]');
			if ($modal.length) return $modal;

			$modal = $(
				'<div class="apply-vacancy-modal" data-apply-modal role="dialog" aria-modal="true" aria-labelledby="apply-vacancy-title">' +
					'<div class="apply-vacancy-modal__dialog">' +
						'<div class="apply-vacancy-modal__header">' +
							window.___('<div><h3 id="apply-vacancy-title">Відгукнутися на вакансію</h3><p data-apply-subtitle></p></div>') +
							window.___('<button type="button" class="apply-vacancy-modal__close" data-apply-close aria-label="Закрити"><i class="uil uil-times"></i></button>') +
						'</div>' +
						'<div class="apply-vacancy-modal__body" data-apply-body></div>' +
						'<div class="apply-vacancy-modal__footer" data-apply-footer></div>' +
					'</div>' +
				'</div>'
			).appendTo('body');

			return $modal;
		}

		function nextFrame(callback) {
			if (window.requestAnimationFrame) {
				window.requestAnimationFrame(function () {
					window.requestAnimationFrame(callback);
				});
			} else {
				setTimeout(callback, 20);
			}
		}

		function openModal() {
			const $modal = modal();
			$('body').addClass('apply-vacancy-modal-open');
			$modal.removeClass('is-closing is-open');
			nextFrame(function () {
				$modal.addClass('is-open');
			});
			setTimeout(function () {
				$modal.find('button, a, input, textarea').filter(':visible').first().trigger('focus');
			}, 260);
		}

		function closeModal() {
			const $modal = modal();
			$modal.addClass('is-closing').removeClass('is-open');
			setTimeout(function () {
				$modal.removeClass('is-closing');
				$('body').removeClass('apply-vacancy-modal-open');
				if (lastTrigger) $(lastTrigger).trigger('focus');
			}, 200);
		}

		function messageState(title, text, actions) {
			const $modal = modal();
			$modal.find('#apply-vacancy-title').text(title);
			$modal.find('[data-apply-subtitle]').text(text || '');
			$modal.find('[data-apply-body]').empty();
			const $footer = $modal.find('[data-apply-footer]').empty();

			(actions || [{label: window.___('Закрити'), className: 'btn border border-slate-200 dark:border-slate-700 rounded-md', click: closeModal}]).forEach(function (action) {
				const $el = action.href ? $('<a></a>').attr('href', action.href) : $('<button type="button"></button>').on('click', action.click || closeModal);
				$el.addClass(action.className || 'btn border border-slate-200 dark:border-slate-700 rounded-md').text(action.label).appendTo($footer);
			});

			openModal();
		}

		function refreshSubmit() {
			const $form = $('[data-apply-form]');
			const valid = $form.find('input[name="resume_id"]:checked').length
				&& (($form.find('textarea[name="message"]').val() || '').length <= 1000);
			$('[data-apply-submit]').prop('disabled', !valid);
		}

		function clearConfirmError() {
			$('[data-apply-confirm]').removeClass('is-error');
			$('[data-apply-error]').removeClass('is-visible').text('');
		}

		function showConfirmError() {
			const $confirm = $('[data-apply-confirm]');
			const $body = $('[data-apply-body]');
			$confirm.addClass('is-error');
			$('[data-apply-error]').text(confirmErrorMessage).addClass('is-visible');

			if ($body.length && $confirm.length) {
				$body.stop().animate({
					scrollTop: $body.scrollTop() + $confirm.position().top - 16
				}, 420, 'swing');
			}

			const input = $confirm.find('input[name="confirm_actual"]')[0];
			if (input && input.focus) {
				try {
					input.focus({preventScroll: true});
				} catch (error) {
					$(input).trigger('focus');
				}
			}
		}

		function renderForm(data, source) {
			payload = data;
			const $modal = modal();
			const vacancy = data.vacancy;
			const selectedId = data.selected_resume_id || data.resumes[0].id;
			const meta = [vacancy.city, vacancy.work_format, vacancy.employment_type].filter(Boolean).join(' · ');

			$modal.find('#apply-vacancy-title').text(window.___('Відгукнутися на вакансію'));
			$modal.find('[data-apply-subtitle]').text(window.___('Оберіть резюме та, за бажанням, додайте коротке повідомлення роботодавцю.'));

			const resumes = data.resumes.map(function (resume) {
				const checked = String(selectedId) === String(resume.id) ? ' checked' : '';
				return '<label class="apply-resume-card">' +
					'<input type="radio" name="resume_id" value="' + resume.id + '"' + checked + '>' +
					'<span class="apply-resume-card__content">' +
						'<strong>' + escapeHtml(resume.title) + '</strong>' +
						(resume.roles ? '<small>' + escapeHtml(resume.roles) + '</small>' : '') +
						'<em>' + escapeHtml([resume.cities, resume.salary].filter(Boolean).join(' · ')) + '</em>' +
						'<b>' + escapeHtml(resume.status) + (resume.updated ? window.___(' · Оновлено ') + escapeHtml(resume.updated) : '') + (data.resumes.length === 1 ? window.___(' · Обрано автоматично') : '') + '</b>' +
						(resume.active ? '' : window.___('<div class="apply-resume-warning">Це резюме приховане в пошуку, але ви можете надіслати його роботодавцю у відгуку.</div>')) +
					'</span>' +
				'</label>';
			}).join('');

			$modal.find('[data-apply-body]').html(
				'<form data-apply-form data-apply-url="' + escapeHtml(data.apply_url) + '" data-source="' + escapeHtml(source || 'site') + '" data-offer-id="' + escapeHtml(data.offer_id || '') + '">' +
					'<div class="apply-vacancy-card"><h4>' + escapeHtml(vacancy.title) + '</h4><strong>' + escapeHtml(vacancy.company) + '</strong>' +
						(meta ? '<p>' + escapeHtml(meta) + '</p>' : '') + '<span>' + escapeHtml(vacancy.salary || window.___('Зарплата не вказана')) + '</span></div>' +
					window.___('<section class="apply-modal-section"><div class="apply-modal-section__head"><h4>Оберіть резюме</h4><p>Роботодавець отримає вибране резюме разом із вашим відгуком.</p></div><div class="apply-resume-list">') + resumes + '</div><a href="' + escapeHtml(data.create_resume_url) + window.___('" class="apply-modal-link">Створити нове резюме</a></section>') +
					window.___('<section class="apply-modal-section"><label class="apply-field"><span>Повідомлення роботодавцю</span><textarea name="message" maxlength="1000" placeholder="Напишіть коротко, чому вас зацікавила ця вакансія або чому ви підходите на цю роль"></textarea></label><div class="apply-field-help">Необов’язково, але коротке повідомлення може допомогти роботодавцю швидше зрозуміти вашу мотивацію. <b data-message-count>0 / 1000</b></div><div class="apply-field-error" data-message-error>Повідомлення не може бути довшим за 1000 символів.</div></section>') +
					window.___('<section class="apply-modal-section"><div class="apply-modal-section__head"><h4>Контактні дані</h4><p>Роботодавець зможе побачити ваші контакти після отримання відгуку.</p></div><div class="apply-contact-grid">') +
						'<span><i class="uil uil-user"></i>' + escapeHtml(data.contact.name) + '</span><span><i class="uil uil-envelope"></i>' + escapeHtml(data.contact.email) + '</span><span><i class="uil uil-phone"></i>' + escapeHtml(data.contact.phone || window.___('Телефон не вказано')) + '</span><span><i class="uil uil-map-marker"></i>' + escapeHtml(data.contact.city || window.___('Місто не вказано')) + '</span></div>' +
						(data.contact.phone_missing ? window.___('<div class="apply-contact-warning">У профілі не вказано телефон. Додайте номер, щоб роботодавець міг швидше зв’язатися з вами.</div>') : '') +
						'<a href="' + escapeHtml(data.profile_url) + window.___('" class="apply-modal-link">Редагувати особисті дані</a></section>') +
					window.___('<label class="apply-confirm" data-apply-confirm><input type="checkbox" name="confirm_actual" value="1"><span>Підтверджую, що вибране резюме та контактні дані актуальні.</span></label><div class="apply-field-error" data-apply-error></div>') +
				'</form>'
			);

			$modal.find('[data-apply-footer]').html(window.___('<button type="button" class="btn border border-slate-200 dark:border-slate-700 hover:border-emerald-600 hover:text-emerald-600 rounded-md" data-apply-cancel>Скасувати</button><button type="button" class="btn bg-emerald-600 hover:bg-emerald-700 border-emerald-600 text-white rounded-md" data-apply-submit disabled>Надіслати відгук</button>'));
			openModal();
			refreshSubmit();
		}

		function renderSuccess(response) {
			const vacancy = payload ? payload.vacancy : null;
			const application = response.application || {};
			const $modal = modal();
			$modal.find('#apply-vacancy-title').text(window.___('Відгук надіслано'));
			$modal.find('[data-apply-subtitle]').text(window.___('Ваш відгук передано роботодавцю. Статус можна відстежувати в історії відгуків.'));
			$modal.find('[data-apply-body]').html('<div class="apply-success-card"><div class="apply-success-card__icon"><i class="uil uil-check-circle"></i></div>' + (vacancy ? '<h4>' + escapeHtml(vacancy.title) + '</h4>' : '') + (application.resume_title ? window.___('<p>Резюме: ') + escapeHtml(application.resume_title) + '</p>' : '') + (application.created_at ? window.___('<p>Дата відгуку: ') + escapeHtml(application.created_at) + '</p>' : '') + '</div>');
			$modal.find('[data-apply-footer]').html('<a href="' + escapeHtml(application.history_url || '/profile/applications') + window.___('" class="btn bg-emerald-600 hover:bg-emerald-700 border-emerald-600 text-white rounded-md">Перейти до історії відгуків</a>') + (vacancy ? '<a href="' + escapeHtml(vacancy.url) + window.___('" class="btn border border-slate-200 dark:border-slate-700 hover:border-emerald-600 hover:text-emerald-600 rounded-md">Переглянути вакансію</a>') : '') + window.___('<button type="button" class="btn border border-slate-200 dark:border-slate-700 rounded-md" data-apply-close>Закрити</button>'));
		}

		function markApplied(jobId) {
			$('[data-jobs-apply-button][data-job-id="' + jobId + '"], .js-apply-vacancy[data-job-id="' + jobId + '"]').each(function () {
				$(this).addClass('is-applied').removeAttr('data-apply-url').html(window.___('<i class="uil uil-check-circle"></i> Ви вже відгукнулися'));
			});
			$('[data-jobs-apply-message]').text(window.___('Роботодавець отримав ваш відгук.'));
		}

		function handleApplyClick(trigger, event) {
			if (event) {
				event.preventDefault();
				event.stopPropagation();
				if (event.stopImmediatePropagation) event.stopImmediatePropagation();
			}

			const $button = $(trigger);
			const modalUrl = $button.data('modal-url');
			if (!modalUrl) return;

			lastTrigger = trigger;
			$button.addClass('is-loading');
			$.ajax({url: modalUrl, method: 'GET', dataType: 'json', headers: {'Accept': 'application/json'}})
				.done(function (response) {
					if (response.state === 'auth_required') {
						messageState(window.___('Увійдіть, щоб відгукнутися'), window.___('Щоб надіслати відгук роботодавцю, увійдіть у профіль шукача або створіть акаунт.'), [
							{label: window.___('Увійти'), href: response.login_url, className: 'btn bg-emerald-600 hover:bg-emerald-700 border-emerald-600 text-white rounded-md'},
							{label: window.___('Зареєструватися'), href: response.registration_url, className: 'btn border border-slate-200 dark:border-slate-700 hover:border-emerald-600 hover:text-emerald-600 rounded-md'},
							{label: window.___('Закрити'), className: 'btn border border-slate-200 dark:border-slate-700 rounded-md', click: closeModal}
						]);
					} else if (response.state === 'employer_forbidden') {
						messageState(window.___('Отклик доступний тільки шукачам'), window.___('Щоб відгукнутися на вакансію, потрібно увійти як шукач.'));
					} else if (response.state === 'already_applied') {
						messageState(window.___('Відгук уже надіслано'), window.___('Ви вже відгукнулися на цю вакансію. Переглянути статус можна в історії відгуків.'), [
							{label: window.___('Перейти до історії відгуків'), href: response.history_url, className: 'btn bg-emerald-600 hover:bg-emerald-700 border-emerald-600 text-white rounded-md'},
							{label: window.___('Закрити'), className: 'btn border border-slate-200 dark:border-slate-700 rounded-md', click: closeModal}
						]);
					} else if (response.state === 'no_resumes') {
						messageState(window.___('Створіть резюме, щоб відгукнутися'), window.___('Роботодавець отримає ваш відгук разом із резюме. Створіть резюме, щоб продовжити.'), [
							{label: window.___('Створити резюме'), href: response.create_resume_url, className: 'btn bg-emerald-600 hover:bg-emerald-700 border-emerald-600 text-white rounded-md'},
							{label: window.___('Закрити'), className: 'btn border border-slate-200 dark:border-slate-700 rounded-md', click: closeModal}
						]);
					} else if (response.state === 'unavailable') {
						messageState(window.___('Вакансія недоступна'), window.___('Роботодавець більше не приймає відгуки на цю вакансію.'));
					} else if (response.state === 'ready') {
						renderForm(response, $button.data('source') || 'site');
					}
				})
				.fail(function () { messageState(window.___('Не вдалося надіслати відгук'), window.___('Спробуйте ще раз.')); })
				.always(function () { $button.removeClass('is-loading'); });
		}

		document.addEventListener('click', function (event) {
			const trigger = event.target.closest ? event.target.closest('.js-apply-vacancy') : null;
			if (trigger) handleApplyClick(trigger, event);
		}, true);

		$(document).on('click', '[data-apply-close], [data-apply-cancel]', closeModal);
		$(document).on('click', '[data-apply-modal]', function (event) { if (event.target === this) closeModal(); });
		$(document).on('keydown', function (event) { if (event.key === 'Escape' && $('[data-apply-modal]').hasClass('is-open')) closeModal(); });
		$(document).on('change', '[data-apply-form] input[name="resume_id"], [data-apply-form] input[name="confirm_actual"]', function () {
			if ($(this).attr('name') === 'confirm_actual' && $(this).is(':checked')) clearConfirmError();
			refreshSubmit();
		});
		$(document).on('input', '[data-apply-form] textarea[name="message"]', function () {
			const length = ($(this).val() || '').length;
			$('[data-message-count]').text(length + ' / 1000');
			$('[data-message-error]').toggleClass('is-visible', length > 1000);
			refreshSubmit();
		});
		$(document).on('click', '[data-apply-submit]', function () {
			const $button = $(this);
			const $form = $('[data-apply-form]');
			const jobId = lastTrigger ? $(lastTrigger).data('job-id') : null;
			const messageLength = ($form.find('textarea[name="message"]').val() || '').length;

			if (!$form.find('input[name="confirm_actual"]').is(':checked')) {
				showConfirmError();
				return;
			}
			if (messageLength > 1000) return;

			clearConfirmError();
			$button.prop('disabled', true).text(window.___('Надсилаємо...'));
			$.ajax({
				url: $form.data('apply-url'),
				method: 'POST',
				dataType: 'json',
				headers: {'X-CSRF-TOKEN': token, 'Accept': 'application/json'},
				data: {
					resume_id: $form.find('input[name="resume_id"]:checked').val(),
					message: $form.find('textarea[name="message"]').val(),
					confirm_actual: $form.find('input[name="confirm_actual"]').is(':checked') ? 1 : 0,
					source: $form.data('source') || 'site',
					offer_id: $form.data('offer-id') || ''
				}
			}).done(function (response) {
				if (jobId) markApplied(jobId);
				$(document).trigger('candidate:application-sent', [response, jobId, $form.data('offer-id') || response.offer_id || null]);
				renderSuccess(response);
			}).fail(function (xhr) {
				let message = window.___('Не вдалося надіслати відгук. Спробуйте ще раз.');
				if (xhr.status === 404) message = window.___('Ця вакансія більше недоступна.');
				if (xhr.status === 401) message = window.___('Сесія завершилася. Увійдіть ще раз, щоб продовжити.');
				if (xhr.status === 422 && xhr.responseJSON && xhr.responseJSON.errors) message = Object.values(xhr.responseJSON.errors)[0][0] || message;
				$('[data-apply-error]').text(message).addClass('is-visible');
				$button.prop('disabled', false).text(window.___('Надіслати відгук'));
			});
		});
	});
})(jQuery);
